import { Route } from '@angular/router';
import { AuthGuard } from '../../../shared/services';
import { CitizensForImpactListComponent } from './citizens-for-impact-list.component';

export const CitizensForImpactListRoutes: Route[] = [
  {
    path: 'list',
    component: CitizensForImpactListComponent,
    canActivate: [AuthGuard],
    resolve: {}
  }
];
